import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'
import { suspensePage } from '@/routes/suspensePage'

const SharedDeckPage = lazy(() => import('@/pages/shared/SharedDeckPage'))
const SharedBuylistPage = lazy(() => import('@/pages/shared/SharedBuylistPage'))
const SharedSelllistPage = lazy(() => import('@/pages/shared/SharedSelllistPage'))
const SharedBinderPage = lazy(() => import('@/pages/binders/SharedBinderPage'))

/** Share-link pages: viewable by anyone holding the token, inside the app shell. */
export const sharedRoutes: RouteObject[] = [
  { path: 'shared/decks/:shareToken', element: suspensePage(SharedDeckPage) },
  { path: 'shared/buylist/:shareToken', element: suspensePage(SharedBuylistPage) },
  { path: 'shared/selllist/:shareToken', element: suspensePage(SharedSelllistPage) },
  { path: 'shared/binders/:shareToken', element: suspensePage(SharedBinderPage) },
]
